import { injectable } from "inversify"

import * as Api from "../constants/ApiUrlConstants"
import container from "../wires/Bootstrapper"
import SERVICE_IDENTIFIER from "../wires/Identifiers"

import { IApiService } from "./shared/ApiService"
import { IApiServiceExt } from "./shared/ApiServiceExt"

import { ModelBase } from "../models/ModelBase"
import { YapilyConsensiTestoModel, YapilyFlowModel, YapilyLookup, YapilyLookupModel } from "../models/YapilyModels"

export interface IYapilyService {
    // ModelBase StartAuthFlow(YapilyFlowModel model);

    StartAuthFlow(model: YapilyFlowModel): Promise<ModelBase>
    StartAuthEmbeddedFlow(model: YapilyFlowModel): Promise<YapilyFlowModel>
    UpdateAuthEmbeddedFlowScaMethodChoise(model: YapilyFlowModel): Promise<YapilyFlowModel>
    UpdateAuthEmbeddedFlowScaCode(model: YapilyFlowModel): Promise<YapilyFlowModel>
    GetConsent(model: YapilyFlowModel): Promise<YapilyFlowModel>
    Revoca(consentToken: string): Promise<ModelBase>

    Search(): Promise<YapilyLookupModel>
    Save(model: YapilyLookup): Promise<ModelBase>
    Delete(id: string): Promise<ModelBase>
    ImportYapilyLookup(file: File): Promise<ModelBase>
    UpdateEmbeddedFlow(): Promise<ModelBase>
    ExportYapilyLookup()
    ConsensiTesto(id: string): Promise<YapilyConsensiTestoModel>
}

@injectable()
export class YapilyService implements IYapilyService {

    apiService: IApiService
    apiServiceExt: IApiServiceExt

    constructor() {
        this.apiService = container.get(SERVICE_IDENTIFIER.API_SERVICE)
        this.apiServiceExt = container.get(SERVICE_IDENTIFIER.API_SERVICE_EXT)
    }

    async StartAuthFlow(model: YapilyFlowModel): Promise<ModelBase> {
        return this.apiService.postAsync(Api.YapilyStartAuthFlow, model)
    }

    async StartAuthEmbeddedFlow(model: YapilyFlowModel): Promise<YapilyFlowModel> {
        return this.apiService.postAsync(Api.YapilyStartAuthEmbeddedFlow, model)
    }

    async UpdateAuthEmbeddedFlowScaMethodChoise(model: YapilyFlowModel): Promise<YapilyFlowModel> {
        return this.apiService.postAsync(Api.YapilyUpdateAuthEmbeddedFlowScaMethodChoise, model)
    }

    async UpdateAuthEmbeddedFlowScaCode(model: YapilyFlowModel): Promise<YapilyFlowModel> {
        return this.apiService.postAsync(Api.YapilyUpdateAuthEmbeddedFlowScaCode, model)
    }

    async GetConsent(model: YapilyFlowModel): Promise<YapilyFlowModel> {
        return this.apiService.postAsync(Api.YapilyGetConsent, model)
    }


    async Revoca(consentToken: string): Promise<ModelBase> {
        return this.apiService.getAsync(Api.YapilyRevoca, { consentToken: consentToken })
    }

    async Search(): Promise<YapilyLookupModel> {
        return this.apiService.getAsync(Api.YapilySearchLookup, {})
    }

    async Save(model: YapilyLookup): Promise<ModelBase> {
        return this.apiService.postAsync(Api.YapilySaveLookup, model)
    }

    async Delete(id: string): Promise<ModelBase> {
        return this.apiService.getAsync(Api.YapilyDeleteLookup, { id: id })
    }

    async ImportYapilyLookup(file: File): Promise<ModelBase> {
        let formData = new FormData()
        formData.append("File", file)
        return this.apiService.postAsync(Api.YapilyImportYapilyLookup, formData)
    }

    async UpdateEmbeddedFlow(): Promise<ModelBase> {
        return this.apiService.getAsync(Api.YapilyUpdateEmbeddedFlow, null)
    }

    ExportYapilyLookup() {
        let url = "/api" + Api.YapilyExportYapilyLookup
        this.apiService.downloadFileToken(url);
    }

    async ConsensiTesto(id: string): Promise<YapilyConsensiTestoModel> {
        return this.apiService.getAsync(Api.YapilyConsensiTesto, { id: id })
    }
}

